module.exports = __webpack_public_path__ + "img/icon9.758935a4.png";